import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { IconSpriteModule } from '@personal-area/icon-sprite';

@Component({
  selector: 'pac-navigation-layout',
  templateUrl: './navigation-layout.component.html',
  styleUrls: ['./navigation-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, IconSpriteModule],
})
export class NavigationLayoutComponent {
  @Input() sidebarVisible: boolean = false;
  @Output() backdropClick = new EventEmitter<void>();

  public onBackdropClick(): void {
    this.backdropClick.emit();
  }
}
